import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DivisionsState } from '../reducers/divisions.reducer';
import { DIVISIONS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<DivisionsState>(DIVISIONS_FEATURE_KEY);

export const selectDivisions = createSelector(selectState, (state: DivisionsState) => state.divisions);
export const selectLoaded = createSelector(selectState, (state: DivisionsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: DivisionsState) => state.loading);
export const selectValue = createSelector(selectState, (state: DivisionsState) => state.value);
export const selectTotal = createSelector(selectState, (state: DivisionsState) => state.total);
export const selectLookupLoaded = createSelector(selectState, (state: DivisionsState) => state.lookupLoaded);
export const selectLookup = createSelector(selectState, (state: DivisionsState) => state.lookup);
